import { AnyAction } from 'redux';
import { parseComponentTree } from 'lib/components/StoryBlok/factories';

import { FLEET_SWITCHING_TERMS_AND_CONDITIONS_SUCCESS } from './types';

export interface FleetSwitchingStoryBlokState {
  loading: boolean;
  TAndCContent?: any;
}

const initialState: FleetSwitchingStoryBlokState = { loading: false };

export const fleetSwitchingReducer = (
  state: FleetSwitchingStoryBlokState = initialState,
  action: AnyAction,
) => {
  switch (action.type) {
    case FLEET_SWITCHING_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        TAndCContent: parseComponentTree(action.payload.story.content),
      };
    default:
      return state;
  }
};

export default fleetSwitchingReducer;
